import styled from 'react-emotion';
import UnstyledButton from '@ublend-npm/aulaui-next-web/Button';
import BaseIconButton from '@ublend-npm/aulaui-next-web/IconButton';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';
import UnstyledVisibilityOffIcon from '@material-ui/icons/VisibilityOffSharp';

export const Button = styled(UnstyledButton, {
  shouldForwardProp: (prop) => prop !== 'show',
})`
  display: ${(props) => (props.show ? 'inline-flex' : 'none')};
  border: 1px solid ${colors.blackAlpha(0.12)};
  box-sizing: border-box;
  border-radius: 4px;
  background: ${(props) =>
    props.secondary ? 'none' : colors.designSystem.purple70};
  color: ${(props) =>
    props.secondary ? colors.designSystem.purple70 : colors.white};
  margin-left: 16px;
  height: 32px;
  min-height: 32px;
  padding: 0 ${theme.spacing.medium};
  div {
    line-height: 1em;
  }
  svg {
    font-size: 20px;
  }

  & :disabled {
    background-color: ${colors.blackAlpha(0.12)};
    color: ${colors.blackAlpha(0.38)};
  }
`;

export const IconButton = styled(BaseIconButton)`
  color: ${colors.blackAlpha(0.6)};
  background: transparent;
  cursor: pointer;
  width: 32px;
  height: 32px;
  margin-left: 8px;
`;

export const Container = styled('div')`
  display: flex;
  justify-content: ${(props) => (props.hidden ? 'space-between' : 'flex-end')};
  flex-direction: row;
  margin-bottom: ${theme.spacing.small};
`;

export const ActionsContainer = styled('div')`
  display: flex;
  justify-content: flex-end;
`;

export const PageDetailsContainer = styled('div')`
  color: ${colors.blackAlpha(0.6)};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  min-width: 30px;
`;

export const VisibilityOffIcon = styled(UnstyledVisibilityOffIcon)`
  padding-right: 6px;
  width: 24px;
  height: 24px;
`;
